import './style.scss'
import { useContext, useEffect, useState } from 'react';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { 
    AbsoluteContainer, AppSpan, AppText, Button, 
    CustomContainer, FlexColumn, FlexRow, GridContainer, 
    ScreenContainer 
} from 'src/style';
import { 
    AddFundD2, ComingSoon, FundsLiquidationD2, 
    InvestmentDetailsD2, NewInvestmentD2, NewSavingsD2, 
    SavingsDetailsD2, Table 
} from 'src/component'
import { transactionColumns, InvestmentColumns, investmentData, savingsData } from 'src/utils/tableLayout';
import { MdAdd } from 'react-icons/md';
import { Features } from 'src/model';


export const InvestmentD2: React.FC = () => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [rowData, setRowData] = useState<any>(null)
    const [fixedDeposits, setFixedDeposit] = useState<any>(null)
    const [navPosition, setNavPosition] = useState(0)
    const [view, setView] = useState('')

    useEffect(() => {
        handleFetchFixedDeposit()
    }, [])

    useEffect(() => {
        if(institutionData?.id && !institutionData.featureIDs?.includes(Features.FIXED_DEPOSIT)) {
            setNavPosition(12.7)
        }
    }, [institutionData])

    async function handleFetchFixedDeposit () {
        const response = await API.getFixedDeposit()
        if (response) {
            setFixedDeposit(response)
        }
    }

    function handleTableRow (data: any) {
        setRowData(data)
        setView(navPosition === 0 ? 'investment-details' : 'savings-details')
    }

    return (
        <>
            <ScreenContainer padding='2.5'>
                <CustomContainer
                    customRadius='10px 10px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                >
                    <CustomContainer>
                        <AppSpan textSize='2.2' fontWeight='700'>Investment</AppSpan>
                    </CustomContainer>
                    { (institutionData.featureIDs?.includes(Features.FIXED_DEPOSIT) && institutionData.featureIDs?.includes(Features.TARGET_SAVINGS)) &&
                        <CustomContainer
                            className='scrollable-container'
                        >
                            <CustomContainer 
                                topMargin="2" width='29.2'
                                radius='0.5' height='4.5' 
                                bgColor='#F4FFFE'
                            >
                                <AbsoluteContainer 
                                    width={navPosition === 0 ? '28' : '15'}
                                    left={navPosition === 0 ? '0.5' : '15'}
                                    className='d3-toggled-wrapper'
                                >
                                    <CustomContainer 
                                        bgColor="#0EA59D" height="3.6" radius='0.6'
                                    />
                                </AbsoluteContainer>
                                <FlexRow 
                                    zIndex="2" gap='2'
                                    height='100' hUnit='%'
                                    style={{minWidth: 'fit-content'}} 
                                >
                                    <GridContainer 
                                        height="100" hUnit='%'
                                        onClick={() => setNavPosition(0)}
                                    >
                                        <AppSpan 
                                            fontWeight='600' cursor="pointer"
                                            color={navPosition === 0 ? "#ffffff" : "#667085"}
                                        >
                                            Fixed Deposit
                                        </AppSpan>
                                    </GridContainer>
                                    {/* <GridContainer 
                                        height="100" hUnit='%'
                                        onClick={() => setNavPosition(12.7)}
                                    >
                                        <AppSpan 
                                            fontWeight='600' cursor="pointer"
                                            color={navPosition === 12.7 ? "#ffffff" : "#667085"}
                                        >
                                            Target Savings
                                        </AppSpan>
                                    </GridContainer> */}
                                </FlexRow>
                            </CustomContainer>
                        </CustomContainer>
                    }
                    { navPosition === 0 ?
                        <CustomContainer
                            borderColor='#EAECF0' radius='0.8' topMargin='3'
                            shadow='0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)'
                        >
                            <FlexColumn minHeight='8' padding='2' alignItems='flex-start'>
                                <FlexRow justifyContent='space-between' gap='2' wrap='wrap'>
                                    <AppText textSize='1.8' fontWeight='600' color='#101828'>Active {navPosition === 0 ? 'Investments' : 'Savings'}</AppText>
                                    <Button
                                        width='auto' sizeUnit='' height='4' borderColor='#0D968F'
                                        hoverColor='#0D968F' hoverBgColor='#fff' titleSize='1.4'
                                        rightPadding='1.5' leftPadding='1.5'
                                        onClick={() => setView(navPosition === 0 ? 'new-investment' : 'new-savings')}
                                    >
                                        <MdAdd style={{marginRight: '1rem', fontSize: '2rem'}} />
                                        New {navPosition === 0 ? 'Investment' : 'Savings'}
                                    </Button>
                                </FlexRow>
                            </FlexColumn>
                            <Table
                                tableColumns={navPosition === 0 ? InvestmentColumns(handleTableRow,institutionData?.defaultCurrency) : transactionColumns(handleTableRow,institutionData?.defaultCurrency)}
                                tableData={navPosition === 0 ? fixedDeposits : savingsData}
                                noDataText={`No Active ${navPosition === 0 ? 'Investments' : 'Savings'}`}
                                noRadius
                                customStyle
                            />
                        </CustomContainer>
                        : 
                        <ComingSoon />
                    }
                </CustomContainer>
            </ScreenContainer>
            { view === 'new-investment' &&
                <NewInvestmentD2
                    close={() => setView('')}
                    getUpdatedInvestments={() => handleFetchFixedDeposit()}
                />
            }
            { view === 'new-savings' &&
                <NewSavingsD2
                    close={() => setView('')} 
                />
            }
            { view === 'investment-details' &&
                <InvestmentDetailsD2
                    close={() => setView('')} 
                    data={rowData}
                    handleLiquidate={() => setView('liquidate-fund')} 
                    handleAddFund={() => setView('add-fund')}
                />
            }
            { view === 'savings-details' &&
                <SavingsDetailsD2
                    close={() => setView('')} 
                    data={rowData}
                    handleLiquidate={() => setView('liquidate-fund')}
                    handleAddFund={() => setView('add-fund')}
                />
            }
            { view === 'add-fund' &&
                <AddFundD2
                    data={rowData}
                    close={() => setView('')}
                    type={navPosition === 0 ? 'investment' : 'savings'}
                    back={() => setView(navPosition === 0 ? 'investment-details' : 'savings-details')} 
                    getUpdatedInvestments={() => navPosition === 0 ? handleFetchFixedDeposit(): null}
                />
            }
            { view === 'liquidate-fund' &&
                <FundsLiquidationD2
                    data={rowData}
                    close={() => setView('')}
                    type={navPosition === 0 ? 'investment' : 'savings'}
                    back={() => setView(navPosition === 0 ? 'investment-details' : 'savings-details')} 
                    getUpdatedInvestments={() => navPosition === 0 ? handleFetchFixedDeposit(): null}
                />
            }
        </>
    );
}